export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11568.685b4126.jpg";